import React from "react"
import { Redirect } from "react-router-dom"
// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import ResetPassword from "../pages/Authentication/ResetPassword"
// import userlist from "../pages/users/userlist"
// Dashboard
import Dashboard from "../pages/Dashboard/index"
import ClientsList from "../pages/Clients/ClientsList"
import Client from "pages/Clients/Client"
import AdminList from "pages/Admin/AdminList"
import UserList from "../pages/users/UserList"
import AdminForm from "pages/Admin/AdminForm"
import UserForm from "pages/users/UserForm"
import BookingList from "pages/Booking/BookingList"
import UnAuthorized from "components/UnAuthorized"
import QuotesRequest from "pages/Quotes/QuotesRequest"
import QuotesList from "pages/Quotes/QuotesList"
import Track from "pages/Booking/Track"
import ViewQuotes from "pages/Quotes/ViewQuotes"
import ClientDetails from "pages/Clients/ClientDetails"
import Settings from "pages/Settings/Settings"
import InternalServer from "components/InternalServer"
import BadRequest from "components/BadRequest"
import NotFound from "components/NotFound"
import InnerScreenNotFound from "components/InnerScreenNotFound"
import ShipperInformation from "pages/Quotes/ShipperInformation"
import AirShipperInformation from "pages/Quotes/AirShipperInformation"
import SeaShipperInformation from "pages/Quotes/SeaShipperInformation"

const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard, role: ["SUPER_ADMIN", "ADMIN", "CLIENT"] },
  { path: "/profile", component: UserProfile, role: ["SUPER_ADMIN", "ADMIN", "CLIENT"] },
  { path: "/clients", component: ClientsList, role: ["SUPER_ADMIN", "ADMIN"] },
  { path: "/clients/add-new-client", component: Client, role: ["SUPER_ADMIN", "ADMIN"] },
  { path: "/clients/update-client/:id", component: Client, role: ["SUPER_ADMIN", "ADMIN"] },
  { path: "/clients/client-details/:id", component: ClientDetails, role: ["SUPER_ADMIN", "ADMIN"] },
  { path: "/admin", component: AdminList, role: ["SUPER_ADMIN"] },
  { path: "/admin/add-new-admin", component: AdminForm, role: ["SUPER_ADMIN"] },
  { path: "/admin/update-admin/:id", component: AdminForm, role: ["SUPER_ADMIN"] },
  { path: "/users", component: UserList, role: ["SUPER_ADMIN", "ADMIN"] },
  { path: "/users/add-new-user", component: UserForm, role: ["SUPER_ADMIN", "ADMIN"] },
  { path: "/users/update-user/:id", component: UserForm, role: ["SUPER_ADMIN", "ADMIN"] },
  { path: "/bookings", component: BookingList, role: ["SUPER_ADMIN", "ADMIN", "CLIENT"] },
  { path: "/enquiries/enquiry-request", component: QuotesRequest, role: ["CLIENT"] },
  { path: "/enquiries", component: QuotesList, role: ["SUPER_ADMIN", "ADMIN", "CLIENT"] },
  { path: "/enquiries/update-quote/:id", component: QuotesRequest, role: ["CLIENT"] },
  { path: "/enquiries/air-shipper-information-details/:shipperId", component: AirShipperInformation, role: ["SUPER_ADMIN", "ADMIN", "CLIENT"] },
  { path: "/enquiries/sea-shipper-information-details/:shipperId", component: SeaShipperInformation, role: ["SUPER_ADMIN", "ADMIN", "CLIENT"] },
  { path: "/enquiries/:id", component: ViewQuotes, role: ["SUPER_ADMIN", "ADMIN", "CLIENT"] },
  { path: "/enquiries/add-shipper-information/:quoteId", component: ShipperInformation, role: ["SUPER_ADMIN", "ADMIN", "CLIENT"] },
  { path: "/enquiries/update-shipper-information/:quoteId/:shipperId", component: ShipperInformation, role: ["SUPER_ADMIN", "ADMIN", "CLIENT"] },
  { path: "/bookings/track/:trackId", component: Track, role: ["SUPER_ADMIN", "ADMIN", "CLIENT"] },
  { path: "/bookings/track/:trackId/:containerId", component: Track, role: ["SUPER_ADMIN", "ADMIN", "CLIENT"] },
  { path: "/settings", component: Settings, role: ["SUPER_ADMIN"] },
  { path: "/notfound", component: InnerScreenNotFound, role: ["SUPER_ADMIN", "ADMIN", "CLIENT"] },
  // //profile
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
  { path: "*", component: () => <Redirect to="/notfound" /> },
]
const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/reset-password/:email", component: ResetPassword },
  { path: "/unauthorized", component: UnAuthorized },
  { path: "/servererror", component: InternalServer },
  { path: "/badrequest", component: BadRequest }, 
  
  
]


export { authProtectedRoutes, publicRoutes }
